import useWebSocket, { ReadyState } from "react-use-websocket";
import { useEffect, useState } from "react";
import { useBinanceState } from "../contexts/BinanceContext";

export enum BinanceStable {
  USDT = "usdt",
  USDC = "usdc",
  FDUSD = "fdusd",
}

const isStable = (symbol: string) => {
  return BinanceStable[symbol as keyof typeof BinanceStable] !== undefined;
}

export function useBinanceTicker(symbol: string, stable: BinanceStable) {
  const [price, setPrice] = useState<string | null>(null);
  const { setPrices, setPriceDirections } = useBinanceState();

  if (isStable(symbol) && stable === symbol.toLowerCase() as BinanceStable) {
    return { price: '0', connected: false, isStable: true };
  }

  const streamName = isStable(symbol) ? `${stable.toLowerCase()}${symbol.toLowerCase()}@ticker` : `${symbol.toLowerCase()}${stable.toLowerCase()}@ticker`;
  const wsUrl = `wss://stream.binance.com:9443/stream?streams=${streamName}`;

  const { lastMessage, readyState } = useWebSocket(wsUrl, {
    shouldReconnect: () => true, // автопереподключение
    reconnectAttempts: Infinity,
    reconnectInterval: 1000,
  });

  useEffect(() => {
    if (lastMessage !== null) {
      try {
        const msg = JSON.parse(lastMessage.data);
        const data = msg.data ?? msg; // для ws и stream-mode

        if (data?.c) {
          setPrice(data.c);
          setPrices(prevPrices => {
            const lastPrice = prevPrices[data.s];

            setPriceDirections(prevDirections => {
              const isUp = lastPrice ? parseFloat(data.c) >= parseFloat(lastPrice) : true;

              return {
                ...prevDirections,
                [data.s]: isUp,
              }
            });

            return {
              ...prevPrices,
              [data.s]: data.c,
            }
          });
        }
      } catch (e) {
        console.error("Parse error", e);
      }
    }
  }, [lastMessage]);

  return {
    price,
    connected: readyState === ReadyState.OPEN,
    isStable: false,
  };
}